interface IRouteState {
  go: (route: string) => void
}

class RouteChangeService {
  private $state: IRouteState;

  init($state: IRouteState) {
    this.$state = $state;
  }

  changeRoute(url: string) {
    this.$state.go(url);
  }
}

const instance = new RouteChangeService();
export default instance as RouteChangeService;
